@if (product && product.inStock) {
<href [link]="!canAdd ? product.data?.url : undefined">
    <div class="pos-absolute top-2 right-2 left-2 pe-none z-6 right _wrapper">
        <div class="inline-block pe-auto _inner">
            @if (showOptions) {
            <product-listing-configurable-options class="pos-absolute top-0 right-0 bottom-0 z-1 ng-hide ng-hide-animate"
                                                  [product]="product"
                                                  [color]="color"
                                                  [listPosition]="listPosition" />
            }
            <product-listing-add-to-basket-button class="pos-absolute top-0 right-0 bottom-0 z-2 ng-hide ng-hide-animate"
                                                  [product]="product"
                                                  [canAdd]="canAdd"
                                                  [buyRequest]="buyRequest"
                                                  [listPosition]="listPosition"
                                                  (mouseenter)="handleMouseEnter()"
                                                  (click)="handleMouseEnter()" />
        </div>
    </div>
</href>
}